import * as i0 from '@angular/core';
import { Component, Input, Self, EventEmitter, Output, Directive, HostListener, ViewChild, forwardRef, Injectable, Inject, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { Validators, FormControl, NG_VALUE_ACCESSOR, NG_VALIDATORS, ReactiveFormsModule } from '@angular/forms';
import * as i3 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import { EmailValidator, IbanValidator, EanValidator, VatValidator, normalizeVATNumber, normalizePhoneNumber } from '@totalenergiescode/springbox-validators';

class InputAttributeBase {
}
InputAttributeBase.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputAttributeBase, deps: [], target: i0.ɵɵFactoryTarget.Component });
InputAttributeBase.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputAttributeBase, selector: "ng-component", inputs: { id: "id", label: "label", placeholder: "placeholder", tooltip: "tooltip", errorMessage: "errorMessage" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputAttributeBase, decorators: [{
            type: Component,
            args: [{
                    template: '',
                }]
        }], propDecorators: { id: [{
                type: Input
            }], label: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }] } });

class InputBase extends InputAttributeBase {
    constructor(fb, controller) {
        super();
        this.fb = fb;
        this.controller = controller;
        this.onChange = (value) => { };
        this.onTouched = () => { };
        this.controller && (this.controller.valueAccessor = this);
    }
    ngDoCheck() {
        if (this.control.touched) {
            return;
        }
        if (this.controller?.control?.touched) {
            this.control.markAsTouched();
        }
    }
    validate({ value }) {
        if (!this.control) {
            return {
                invalid: true,
            };
        }
        if (this.control.status === 'INVALID') {
            return {
                invalid: true,
            };
        }
        return {};
    }
    setLabel(label) {
        this.label = label;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    ngOnInit() {
        this.control.valueChanges.subscribe((value) => {
            this.onChange(this.getValue(value));
            this.onTouched();
        });
        this.addValidators();
        this.controller.control?.addValidators([
            this.validate.bind(this),
        ]);
    }
    addValidators() {
        // We need to add the parent validators to the child. There is no general getValidators method so we need to
        // check for the most common validators.
        // @Todo at mre validators to check.
        if (this.controller.control?.hasValidator(Validators.required)) {
            this.setRequired();
        }
    }
    setRequired() {
        this.control.addValidators([Validators.required]);
    }
}
InputBase.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputBase, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl, self: true }], target: i0.ɵɵFactoryTarget.Component });
InputBase.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputBase, selector: "ng-component", usesInheritance: true, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputBase, decorators: [{
            type: Component,
            args: [{
                    template: '',
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl, decorators: [{
                    type: Self
                }] }]; } });

class TooltipComponent {
    constructor() {
        this.position = 'left';
    }
    ngOnInit() { }
}
TooltipComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TooltipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TooltipComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: TooltipComponent, selector: "te-tooltip", inputs: { position: "position", content: "content" }, ngImport: i0, template: `
    <div tabindex="0" class="tooltip" [class]="position">
      <div class="content-wrapper">
        <span>?</span>
        <div class="content">
          <div *ngIf="content" [innerHTML]="content"></div>
          <div *ngIf="!content">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  `, isInline: true, styles: [".content:after{content:\"\";display:block;position:absolute}.top .content:after,.bottom .content:after{width:3rem;height:4rem;left:50%}.left .content:after,.right .content:after{width:4rem;height:3rem;top:2rem}.top .content:after{bottom:-6rem;transform:translate(-50%) perspective(22px) rotateX(-75deg)}.bottom .content:after{top:-6rem;transform:translate(-50%) perspective(22px) rotateX(75deg)}.right .content:after{left:-5rem;transform:perspective(10px) rotateY(-17deg)}.left .content:after{right:-5rem;transform:perspective(10px) rotateY(17deg)}\n"], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'te-tooltip', template: `
    <div tabindex="0" class="tooltip" [class]="position">
      <div class="content-wrapper">
        <span>?</span>
        <div class="content">
          <div *ngIf="content" [innerHTML]="content"></div>
          <div *ngIf="!content">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  `, styles: [".content:after{content:\"\";display:block;position:absolute}.top .content:after,.bottom .content:after{width:3rem;height:4rem;left:50%}.left .content:after,.right .content:after{width:4rem;height:3rem;top:2rem}.top .content:after{bottom:-6rem;transform:translate(-50%) perspective(22px) rotateX(-75deg)}.bottom .content:after{top:-6rem;transform:translate(-50%) perspective(22px) rotateX(75deg)}.right .content:after{left:-5rem;transform:perspective(10px) rotateY(-17deg)}.left .content:after{right:-5rem;transform:perspective(10px) rotateY(17deg)}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { position: [{
                type: Input
            }], content: [{
                type: Input
            }] } });

class InputTextComponent extends InputBase {
    constructor(fb, controller) {
        super(fb, controller);
        this.control = this.fb.group({
            text: [''],
        });
    }
    writeValue(value) {
        this.control && this.control?.get('text')?.setValue(value);
    }
    getValue(value) {
        return value.text;
    }
    setRequired() {
        this.control.get('text')?.addValidators([Validators.required]);
    }
}
InputTextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputTextComponent, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Component });
InputTextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputTextComponent, selector: "te-input-text", inputs: { suffix: "suffix" }, usesInheritance: true, ngImport: i0, template: `<div
    [formGroup]="control"
    class="form-element input-text mt-4"
    [class.errors]="
       (!control.valid || !this.controller.control?.valid) && control.touched
    "
  >
    <div class="flex">
      <label [for]="id">{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>
    <input
      type="text"
      [id]="id"
      placeholder="{{ placeholder }}"
      formControlName="text"
    />
    <span class="suffix" *ngIf="suffix">{{ suffix }}</span>
    <span class="message">
      <ng-container
        *ngIf="
          (!control.valid || !this.controller.control?.valid)  && control.touched
        "
      >
        {{ errorMessage }}
      </ng-container>
    </span>
  </div>`, isInline: true, components: [{ type: TooltipComponent, selector: "te-tooltip", inputs: ["position", "content"] }], directives: [{ type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputTextComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-input-text',
                    template: `<div
    [formGroup]="control"
    class="form-element input-text mt-4"
    [class.errors]="
       (!control.valid || !this.controller.control?.valid) && control.touched
    "
  >
    <div class="flex">
      <label [for]="id">{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>
    <input
      type="text"
      [id]="id"
      placeholder="{{ placeholder }}"
      formControlName="text"
    />
    <span class="suffix" *ngIf="suffix">{{ suffix }}</span>
    <span class="message">
      <ng-container
        *ngIf="
          (!control.valid || !this.controller.control?.valid)  && control.touched
        "
      >
        {{ errorMessage }}
      </ng-container>
    </span>
  </div>`,
                    styles: [],
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }]; }, propDecorators: { suffix: [{
                type: Input
            }] } });

class InputEmailComponent extends InputBase {
    constructor(fb, controller) {
        super(fb, controller);
        this.control = this.fb.group({
            email: this.fb.control('', [EmailValidator.validate]),
        });
    }
    writeValue(value) {
        this.control && this.control.get('email')?.setValue(value);
    }
    getValue(value) {
        return value.email;
    }
    setRequired() {
        this.control.get('email')?.addValidators([Validators.required]);
    }
}
InputEmailComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputEmailComponent, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Component });
InputEmailComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputEmailComponent, selector: "te-input-email", usesInheritance: true, ngImport: i0, template: `
    <div
      class="form-element input-text mt-4"
      [class.errors]="!control.valid && control.touched"
      [formGroup]="control"
    >
      <div class="flex">
        <label [for]="id">{{ label }}</label>
        <te-tooltip
          *ngIf="tooltip?.content"
          [content]="tooltip?.content"
          [position]="tooltip?.position"
        ></te-tooltip>
      </div>
      <input
        [id]="id"
        type="text"
        placeholder="{{ placeholder }}"
        formControlName="email"
      />
      <span class="message">
        <ng-container *ngIf="!control.valid && control.touched">
          {{ errorMessage }}
        </ng-container>
      </span>
    </div>
  `, isInline: true, components: [{ type: TooltipComponent, selector: "te-tooltip", inputs: ["position", "content"] }], directives: [{ type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputEmailComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-input-email',
                    template: `
    <div
      class="form-element input-text mt-4"
      [class.errors]="!control.valid && control.touched"
      [formGroup]="control"
    >
      <div class="flex">
        <label [for]="id">{{ label }}</label>
        <te-tooltip
          *ngIf="tooltip?.content"
          [content]="tooltip?.content"
          [position]="tooltip?.position"
        ></te-tooltip>
      </div>
      <input
        [id]="id"
        type="text"
        placeholder="{{ placeholder }}"
        formControlName="email"
      />
      <span class="message">
        <ng-container *ngIf="!control.valid && control.touched">
          {{ errorMessage }}
        </ng-container>
      </span>
    </div>
  `,
                    styles: [],
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }]; } });

var TooltipPosition;
(function (TooltipPosition) {
    TooltipPosition["Top"] = "top";
    TooltipPosition["Bottom"] = "bottom";
    TooltipPosition["Left"] = "left";
    TooltipPosition["Right"] = "right";
})(TooltipPosition || (TooltipPosition = {}));
var ButtonType;
(function (ButtonType) {
    ButtonType["Primary"] = "primary";
    ButtonType["Secondary"] = "secondary";
})(ButtonType || (ButtonType = {}));
var EnergyType;
(function (EnergyType) {
    EnergyType["Electricity"] = "electricity";
    EnergyType["Gas"] = "gas";
})(EnergyType || (EnergyType = {}));

class ButtonComponent {
    constructor() {
        this.type = ButtonType.Primary;
        this.eAction = new EventEmitter();
    }
    ngOnInit() { }
    submit(e) {
        this.eAction.emit(this.action);
    }
}
ButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: ButtonComponent, selector: "te-button", inputs: { label: "label", type: "type", action: "action" }, outputs: { eAction: "eAction" }, ngImport: i0, template: `
    <button class="btn btn-{{ type }}" (click)="submit($event)">
      {{ label }}
    </button>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-button',
                    template: `
    <button class="btn btn-{{ type }}" (click)="submit($event)">
      {{ label }}
    </button>
  `,
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { label: [{
                type: Input
            }], type: [{
                type: Input
            }], action: [{
                type: Input
            }], eAction: [{
                type: Output
            }] } });

class InputSelectComponent extends InputBase {
    constructor(fb, controller) {
        super(fb, controller);
        this.control = this.fb.group({
            select: this.fb.control(''),
        });
    }
    writeValue(value) {
        this.control && this.control.get('select')?.setValue(value);
    }
    getValue(value) {
        return value.select;
    }
}
InputSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputSelectComponent, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Component });
InputSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputSelectComponent, selector: "te-input-select", inputs: { options: "options" }, usesInheritance: true, ngImport: i0, template: `
    <div [formGroup]="control" class="form-element custom-select">
      <div *ngIf="label || tooltip" class="flex">
        <label *ngIf="label" [for]="id">{{ label }}</label>
        <te-tooltip
          *ngIf="tooltip?.content"
          [content]="tooltip?.content"
          [position]="tooltip?.position"
        ></te-tooltip>
      </div>
      <select [id]="id" formControlName="select">
        <option *ngFor="let option of options" [value]="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>
  `, isInline: true, components: [{ type: TooltipComponent, selector: "te-tooltip", inputs: ["position", "content"] }], directives: [{ type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputSelectComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-input-select',
                    template: `
    <div [formGroup]="control" class="form-element custom-select">
      <div *ngIf="label || tooltip" class="flex">
        <label *ngIf="label" [for]="id">{{ label }}</label>
        <te-tooltip
          *ngIf="tooltip?.content"
          [content]="tooltip?.content"
          [position]="tooltip?.position"
        ></te-tooltip>
      </div>
      <select [id]="id" formControlName="select">
        <option *ngFor="let option of options" [value]="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>
  `,
                    styles: [],
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }]; }, propDecorators: { options: [{
                type: Input
            }] } });

class InputCheckboxComponent extends InputBase {
    constructor(fb, controller) {
        super(fb, controller);
        this.control = this.fb.group({
            checkbox: this.fb.control(''),
        });
        this.big = false;
        this.smallText = false;
    }
    writeValue(value) {
        this.control && this.control.get('checkbox')?.setValue(value);
    }
    getValue(value) {
        return value.checkbox;
    }
}
InputCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputCheckboxComponent, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Component });
InputCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputCheckboxComponent, selector: "te-input-checkbox", inputs: { big: "big", smallText: "smallText" }, usesInheritance: true, ngImport: i0, template: `<div
    class="form-element mt-4"
    [formGroup]="control"
    [class.small-text]="smallText"
    [class.input-checkbox]="!big"
    [class.input-checkbox-big]="big"
  >
    <input
      type="checkbox"
      [id]="id"
      formControlName="checkbox"
      checked="true"
    />
    <label [for]="id">{{ label }}</label>
  </div>`, isInline: true, directives: [{ type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputCheckboxComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-input-checkbox',
                    template: `<div
    class="form-element mt-4"
    [formGroup]="control"
    [class.small-text]="smallText"
    [class.input-checkbox]="!big"
    [class.input-checkbox-big]="big"
  >
    <input
      type="checkbox"
      [id]="id"
      formControlName="checkbox"
      checked="true"
    />
    <label [for]="id">{{ label }}</label>
  </div>`,
                    styles: [],
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }]; }, propDecorators: { big: [{
                type: Input
            }], smallText: [{
                type: Input
            }] } });

class InputRadiosComponent extends InputBase {
    constructor(fb, controller) {
        super(fb, controller);
        this.control = this.fb.group({
            radio: [],
        });
    }
    writeValue(value) {
        this.control && this.control.get('radio')?.setValue(value);
    }
    getValue(value) {
        return value.radio;
    }
}
InputRadiosComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputRadiosComponent, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Component });
InputRadiosComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputRadiosComponent, selector: "te-input-radios", inputs: { options: "options" }, usesInheritance: true, ngImport: i0, template: `<div class="form-element radios" [formGroup]="control">
    <div *ngIf="label || tooltip" class="flex">
      <label *ngIf="label" [for]="id">{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>

    <div class="input-radio mt-4" *ngFor="let option of options; let i = index">
      <input
        type="radio"
        [id]="id + '-' + i"
        [value]="option.value"
        formControlName="radio"
      />
      <label [for]="id + '-' + i">{{ option.label }}</label>
    </div>
  </div>`, isInline: true, components: [{ type: TooltipComponent, selector: "te-tooltip", inputs: ["position", "content"] }], directives: [{ type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputRadiosComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-input-radios',
                    template: `<div class="form-element radios" [formGroup]="control">
    <div *ngIf="label || tooltip" class="flex">
      <label *ngIf="label" [for]="id">{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>

    <div class="input-radio mt-4" *ngFor="let option of options; let i = index">
      <input
        type="radio"
        [id]="id + '-' + i"
        [value]="option.value"
        formControlName="radio"
      />
      <label [for]="id + '-' + i">{{ option.label }}</label>
    </div>
  </div>`,
                    styles: [],
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }]; }, propDecorators: { options: [{
                type: Input
            }] } });

class InputTextareaComponent extends InputBase {
    constructor(fb, controller) {
        super(fb, controller);
        this.control = this.fb.group({
            textarea: this.fb.control(''),
        });
    }
    writeValue(value) {
        this.control && this.control.get('textarea')?.setValue(value);
    }
    getValue(value) {
        return value.textarea;
    }
}
InputTextareaComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputTextareaComponent, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Component });
InputTextareaComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputTextareaComponent, selector: "te-input-textarea", usesInheritance: true, ngImport: i0, template: `
    <div
      [formGroup]="control"
      class="mt-8 form-element textarea"
      [class.errors]="!control.valid && control.touched"
    >
      <div class="flex">
        <label for="{{ id }}">{{ label }}</label>
        <te-tooltip
          *ngIf="tooltip?.content"
          [content]="tooltip?.content"
          [position]="tooltip?.position"
        ></te-tooltip>
      </div>

      <textarea
        placeholder="{{ placeholder }}"
        formControlName="textarea"
        id="{{ id }}"
        cols="30"
        rows="5"
      ></textarea>
      <span class="message">
        <ng-container *ngIf="!control.valid && control.touched">
          {{ errorMessage }}
        </ng-container>
      </span>
    </div>
  `, isInline: true, components: [{ type: TooltipComponent, selector: "te-tooltip", inputs: ["position", "content"] }], directives: [{ type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputTextareaComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-input-textarea',
                    template: `
    <div
      [formGroup]="control"
      class="mt-8 form-element textarea"
      [class.errors]="!control.valid && control.touched"
    >
      <div class="flex">
        <label for="{{ id }}">{{ label }}</label>
        <te-tooltip
          *ngIf="tooltip?.content"
          [content]="tooltip?.content"
          [position]="tooltip?.position"
        ></te-tooltip>
      </div>

      <textarea
        placeholder="{{ placeholder }}"
        formControlName="textarea"
        id="{{ id }}"
        cols="30"
        rows="5"
      ></textarea>
      <span class="message">
        <ng-container *ngIf="!control.valid && control.touched">
          {{ errorMessage }}
        </ng-container>
      </span>
    </div>
  `,
                    styles: [],
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }]; } });

class InputAutocompleteComponent extends InputBase {
    constructor(fb, controller) {
        super(fb, controller);
        this.control = this.fb.group({});
    }
    writeValue(value) {
        this.control && this.control.get('control')?.setValue(value);
    }
    getValue(value) {
        return value;
    }
}
InputAutocompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputAutocompleteComponent, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Component });
InputAutocompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputAutocompleteComponent, selector: "te-input-autocomplete", usesInheritance: true, ngImport: i0, template: '<p>Autocomplete</p>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputAutocompleteComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-input-autocomplete',
                    template: '<p>Autocomplete</p>',
                    styles: [],
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }]; } });

class InputIbanComponent extends InputBase {
    constructor(fb, controller) {
        super(fb, controller);
        this.control = this.fb.group({
            iban: this.fb.control('', [IbanValidator.validate]),
        });
    }
    writeValue(value) {
        this.control && this.control.get('iban')?.setValue(value);
    }
    getValue(value) {
        return value.iban;
    }
    setRequired() {
        this.control.get('iban')?.addValidators([Validators.required]);
    }
}
InputIbanComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputIbanComponent, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Component });
InputIbanComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputIbanComponent, selector: "te-input-iban", usesInheritance: true, ngImport: i0, template: ` <div
    [formGroup]="control"
    class="form-element input-text mt-4"
    [class.errors]="!control.valid && control.touched"
  >
    <div class="flex">
      <label>{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>
    <input type="text" placeholder="{{ placeholder }}" formControlName="iban" />
    <span class="message">
      <ng-container *ngIf="!control.valid && control.touched">
        <span *ngFor="let error of (control.get('iban')?.errors) | keyvalue; let i=index">
          <ng-container *ngIf="i< 1 && errorMessage && errorMessage[error.key]">
            {{ errorMessage[error.key] }}
          </ng-container>
        </span>
      </ng-container>
    </span>
  </div>`, isInline: true, components: [{ type: TooltipComponent, selector: "te-tooltip", inputs: ["position", "content"] }], directives: [{ type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "keyvalue": i3.KeyValuePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputIbanComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-input-iban',
                    template: ` <div
    [formGroup]="control"
    class="form-element input-text mt-4"
    [class.errors]="!control.valid && control.touched"
  >
    <div class="flex">
      <label>{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>
    <input type="text" placeholder="{{ placeholder }}" formControlName="iban" />
    <span class="message">
      <ng-container *ngIf="!control.valid && control.touched">
        <span *ngFor="let error of (control.get('iban')?.errors) | keyvalue; let i=index">
          <ng-container *ngIf="i< 1 && errorMessage && errorMessage[error.key]">
            {{ errorMessage[error.key] }}
          </ng-container>
        </span>
      </ng-container>
    </span>
  </div>`,
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }]; } });

class DigitOnlyDirective {
    constructor(el) {
        this.el = el;
        this.navigationKeys = [
            'Backspace',
            'Delete',
            'Tab',
            'Escape',
            'Enter',
            'Home',
            'End',
            'ArrowLeft',
            'ArrowRight',
            'Clear',
            'Copy',
            'Paste',
        ];
        this.decimalSeparator = ['.', ','];
        this.decimal = false;
        this.isDecimalEmitter = new EventEmitter();
        this.inputElement = el.nativeElement;
    }
    onKeyDown(e) {
        if (
        // Allow: Delete, Backspace, Tab, Escape, Enter, etc
        this.navigationKeys.indexOf(e.key) > -1 ||
            (e.key === 'a' && e.ctrlKey === true) || // Allow: Ctrl+A
            (e.key === 'c' && e.ctrlKey === true) || // Allow: Ctrl+C
            (e.key === 'v' && e.ctrlKey === true) || // Allow: Ctrl+V
            (e.key === 'x' && e.ctrlKey === true) || // Allow: Ctrl+X
            (e.key === 'a' && e.metaKey === true) || // Cmd+A (Mac)
            (e.key === 'c' && e.metaKey === true) || // Cmd+C (Mac)
            (e.key === 'v' && e.metaKey === true) || // Cmd+V (Mac)
            (e.key === 'x' && e.metaKey === true) // Cmd+X (Mac)
        ) {
            return; // let it happen, don't do anything
        }
        // Check if it's a decimal
        if (this.decimalSeparator.includes(e.key)) {
            if (this.decimal) {
                return;
            } // If decimal allow --> let it happen
            if (this.isDecimalEmitter) {
                this.isDecimalEmitter.emit(true);
            } // If output, send emit event
        }
        // Ensure that it is a number and stop the keypress
        if (e.key === ' ' || isNaN(Number(e.key))) {
            e.preventDefault();
        }
    }
    onPaste(event) {
        event.preventDefault();
        // get a digit-only string
        const pastedInput = event?.clipboardData?.getData('text/plain').replace(/\D/g, '');
        document.execCommand('insertText', false, pastedInput);
    }
    onDrop(event) {
        event.preventDefault();
        const textData = event?.dataTransfer?.getData('text').replace(/\D/g, '');
        this.inputElement.focus();
        document.execCommand('insertText', false, textData);
    }
}
DigitOnlyDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DigitOnlyDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
DigitOnlyDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: DigitOnlyDirective, selector: "[DigitOnly]", inputs: { decimal: "decimal" }, outputs: { isDecimalEmitter: "isDecimalEmitter" }, host: { listeners: { "keydown": "onKeyDown($event)", "paste": "onPaste($event)", "drop": "onDrop($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DigitOnlyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[DigitOnly]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { decimal: [{
                type: Input
            }], isDecimalEmitter: [{
                type: Output
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onPaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }], onDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }] } });

class InputEanComponent extends InputBase {
    constructor(fb, controller) {
        super(fb, controller);
        this.control = this.fb.group({
            ean: ['', [EanValidator.validate]],
        });
    }
    writeValue(value) {
        this.control && this.control.get('ean')?.setValue(value);
    }
    getValue(value) {
        return value.ean;
    }
    setRequired() {
        this.control.get('ean')?.addValidators([Validators.required]);
    }
}
InputEanComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputEanComponent, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Component });
InputEanComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputEanComponent, selector: "te-input-ean", usesInheritance: true, ngImport: i0, template: `<div
    [formGroup]="control"
    class="form-element input-text mt-4"
    [class.errors]="!control.valid && control.touched"
  >
    <div class="flex">
      <label>{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>
    <input
      type="tel"
      placeholder="{{ placeholder }}"
      formControlName="ean"
      DigitOnly
    />
    <span class="message">
      <ng-container *ngIf="!control.valid && control.touched">
        <span *ngFor="let error of (control.get('ean')?.errors) | keyvalue; let i=index">
          <ng-container *ngIf="i< 1 && errorMessage && errorMessage[error.key]">
            {{ errorMessage[error.key] }}
          </ng-container>
        </span>
      </ng-container>
    </span>
  </div>`, isInline: true, components: [{ type: TooltipComponent, selector: "te-tooltip", inputs: ["position", "content"] }], directives: [{ type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: DigitOnlyDirective, selector: "[DigitOnly]", inputs: ["decimal"], outputs: ["isDecimalEmitter"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "keyvalue": i3.KeyValuePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputEanComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-input-ean',
                    template: `<div
    [formGroup]="control"
    class="form-element input-text mt-4"
    [class.errors]="!control.valid && control.touched"
  >
    <div class="flex">
      <label>{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>
    <input
      type="tel"
      placeholder="{{ placeholder }}"
      formControlName="ean"
      DigitOnly
    />
    <span class="message">
      <ng-container *ngIf="!control.valid && control.touched">
        <span *ngFor="let error of (control.get('ean')?.errors) | keyvalue; let i=index">
          <ng-container *ngIf="i< 1 && errorMessage && errorMessage[error.key]">
            {{ errorMessage[error.key] }}
          </ng-container>
        </span>
      </ng-container>
    </span>
  </div>`,
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }]; } });

class InputVatComponent extends InputBase {
    constructor(fb, controller) {
        super(fb, controller);
        this.control = this.fb.group({
            vat: this.fb.control('', [VatValidator.validate]),
        });
    }
    writeValue(value) {
        this.control && this.control.get('vat')?.setValue(value);
    }
    getValue(value) {
        return value.vat;
    }
    normalizeVatNumber() {
        const value = this.control.get('vat')?.value;
        this.control.get('vat')?.setValue(normalizeVATNumber(value), {
            onlySelf: true,
            emitEvent: false,
        });
    }
}
InputVatComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputVatComponent, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Component });
InputVatComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputVatComponent, selector: "te-input-vat", usesInheritance: true, ngImport: i0, template: ` <div
    [formGroup]="control"
    class="form-element input-text mt-4"
    [class.errors]="!control.valid && control.touched"
  >
    <div class="flex">
      <label [for]="id">{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>
    <input
      type="text"
      [id]="id"
      (keyup)="normalizeVatNumber()"
      placeholder="{{ placeholder }}"
      formControlName="vat"
    />
    <span class="message">
      <ng-container *ngIf="!control.valid && control.touched">
        {{ errorMessage }}
      </ng-container>
    </span>
  </div>`, isInline: true, components: [{ type: TooltipComponent, selector: "te-tooltip", inputs: ["position", "content"] }], directives: [{ type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputVatComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-input-vat',
                    template: ` <div
    [formGroup]="control"
    class="form-element input-text mt-4"
    [class.errors]="!control.valid && control.touched"
  >
    <div class="flex">
      <label [for]="id">{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>
    <input
      type="text"
      [id]="id"
      (keyup)="normalizeVatNumber()"
      placeholder="{{ placeholder }}"
      formControlName="vat"
    />
    <span class="message">
      <ng-container *ngIf="!control.valid && control.touched">
        {{ errorMessage }}
      </ng-container>
    </span>
  </div>`,
                    styles: [],
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }]; } });

class InputDateComponent extends InputBase {
    constructor(fb, controller) {
        super(fb, controller);
        this.control = this.fb.group({
            date: [''],
        });
    }
    writeValue(value) {
        this.control && this.control.get('date')?.setValue(value);
    }
    getValue(value) {
        return value.date;
    }
    setRequired() {
        this.control.get('date')?.addValidators([Validators.required]);
        if (this.maxDate) {
            this.control.get('date')?.addValidators([maxDateValidator(this.maxDate)]);
        }
        if (this.minDate) {
            this.control.get('date')?.addValidators([minDateValidator(this.minDate)]);
        }
    }
}
InputDateComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputDateComponent, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Component });
InputDateComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputDateComponent, selector: "te-input-date", inputs: { maxDate: "maxDate", minDate: "minDate" }, usesInheritance: true, ngImport: i0, template: `<div
    [formGroup]="control"
    class="form-element input-text mt-4"
    [class.errors]="!control.valid && control.touched"
  >
    <div class="flex">
      <label>{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>
    <input
      type="date"
      placeholder="{{ placeholder }}"
      formControlName="date"
      [min]="minDate"
      [max]="maxDate"
    />
    <span class="message">
      <ng-container *ngIf="!control.valid && control.touched">
        <span *ngFor="let error of (control.get('date')?.errors) | keyvalue; let i=index">
          <ng-container *ngIf="i< 1 && errorMessage && errorMessage[error.key]">
            {{ errorMessage[error.key] }}
          </ng-container>
        </span>
      </ng-container>
    </span>
  </div>`, isInline: true, components: [{ type: TooltipComponent, selector: "te-tooltip", inputs: ["position", "content"] }], directives: [{ type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "keyvalue": i3.KeyValuePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputDateComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-input-date',
                    template: `<div
    [formGroup]="control"
    class="form-element input-text mt-4"
    [class.errors]="!control.valid && control.touched"
  >
    <div class="flex">
      <label>{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>
    <input
      type="date"
      placeholder="{{ placeholder }}"
      formControlName="date"
      [min]="minDate"
      [max]="maxDate"
    />
    <span class="message">
      <ng-container *ngIf="!control.valid && control.touched">
        <span *ngFor="let error of (control.get('date')?.errors) | keyvalue; let i=index">
          <ng-container *ngIf="i< 1 && errorMessage && errorMessage[error.key]">
            {{ errorMessage[error.key] }}
          </ng-container>
        </span>
      </ng-container>
    </span>
  </div>`,
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }]; }, propDecorators: { maxDate: [{
                type: Input
            }], minDate: [{
                type: Input
            }] } });
//@todo: to move to appropriate package
function minDateValidator(min) {
    return (control) => {
        const minDate = new Date(min);
        // parse control value to Date
        const date = new Date(control.value);
        // check if control value is superior to date given in parameter
        if (minDate.getTime() < date.getTime()) {
            return null;
        }
        else {
            return { 'minDate': { value: control.value, expected: minDate } };
        }
    };
}
function maxDateValidator(max) {
    return (control) => {
        const maxDate = new Date(max);
        // parse control value to Date
        const date = new Date(control.value);
        // check if control value is superior to date given in parameter
        if (maxDate.getTime() > date.getTime()) {
            return null;
        }
        else {
            return { 'maxDate': { value: control.value, expected: maxDate } };
        }
    };
}

class InputPhoneComponent extends InputBase {
    constructor(fb, controller) {
        super(fb, controller);
        this.control = this.fb.group({
            phone: this.fb.control(''),
        });
    }
    writeValue(value) {
        this.control && this.control.get('phone')?.setValue(value);
    }
    getValue(value) {
        return value.phone;
    }
    normalizePhoneNumber() {
        const value = this.control.get('phone')?.value;
        this.control.get('phone')?.setValue(normalizePhoneNumber(value), {
            onlySelf: true,
            emitEvent: false,
        });
    }
}
InputPhoneComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputPhoneComponent, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Component });
InputPhoneComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputPhoneComponent, selector: "te-input-phone", usesInheritance: true, ngImport: i0, template: ` <div
    [formGroup]="control"
    class="form-element input-text mt-4"
    [class.errors]="!control.valid && control.touched"
  >
    <div class="flex">
      <label>{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>
    <input
      type="text"
      (keyup)="normalizePhoneNumber()"
      placeholder="{{ placeholder }}"
      formControlName="phone"
    />
    <span class="message">
      <ng-container *ngIf="!control.valid && control.touched">
        {{ errorMessage }}
      </ng-container>
    </span>
  </div>`, isInline: true, components: [{ type: TooltipComponent, selector: "te-tooltip", inputs: ["position", "content"] }], directives: [{ type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputPhoneComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-input-phone',
                    template: ` <div
    [formGroup]="control"
    class="form-element input-text mt-4"
    [class.errors]="!control.valid && control.touched"
  >
    <div class="flex">
      <label>{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>
    <input
      type="text"
      (keyup)="normalizePhoneNumber()"
      placeholder="{{ placeholder }}"
      formControlName="phone"
    />
    <span class="message">
      <ng-container *ngIf="!control.valid && control.touched">
        {{ errorMessage }}
      </ng-container>
    </span>
  </div>`,
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }]; } });

class InputIndex extends InputBase {
    constructor(fb, controller, renderer) {
        super(fb, controller);
        this.renderer = renderer;
    }
    stretchDecimalFieldContent(element, currentLength = 3, currentCharWidth = 10) {
        const computed = getComputedStyle(element.nativeElement);
        const spaceForChar = (element.nativeElement.offsetWidth - parseFloat(computed.paddingLeft) - parseFloat(computed.paddingRight)) / currentLength;
        const charWidth = spaceForChar - currentCharWidth + (spaceForChar - currentCharWidth) / currentLength;
        this.renderer.setStyle(element.nativeElement, 'letterSpacing', `${charWidth}px`);
    }
    stretchUnitFieldContent(element, currentLength = 5, currentCharWidth = 10) {
        const spaceForChar = element.nativeElement.offsetWidth / currentLength;
        const charWidth = spaceForChar - currentCharWidth + (spaceForChar - currentCharWidth) / currentLength;
        this.renderer.setStyle(element.nativeElement, 'letterSpacing', `${charWidth}px`);
        this.renderer.setStyle(element.nativeElement, 'textIndent', `-${charWidth}px`);
    }
}
InputIndex.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputIndex, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
InputIndex.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputIndex, selector: "ng-component", usesInheritance: true, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputIndex, decorators: [{
            type: Component,
            args: [{
                    template: '',
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }, { type: i0.Renderer2 }]; } });

class InputIndexElectricityComponent extends InputIndex {
    constructor(fb, controller, renderer) {
        super(fb, controller, renderer);
        this.control = this.fb.group({
            unit: [''],
            decimal: [''],
        });
        this.onResize = () => super.stretchUnitFieldContent(this.unitInput, 6);
    }
    ngAfterViewInit() {
        super.stretchUnitFieldContent(this.unitInput, 6);
    }
    writeValue(value) {
        if (!this.control || !value) {
            return;
        }
        this.control.setValue({
            unit: Math.floor(+value),
            decimal: +(+value % 1).toFixed(1) * 10,
        });
    }
    getValue(value) {
        const result = +value.unit + +value.decimal / 10;
        return result;
    }
    setRequired() {
        this.control.get('unit')?.addValidators([Validators.required]);
    }
    moveFocusToDecimalInput() {
        this.decimalInput.nativeElement.focus();
    }
}
InputIndexElectricityComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputIndexElectricityComponent, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
InputIndexElectricityComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputIndexElectricityComponent, selector: "te-input-index-electricity", inputs: { suffix: "suffix" }, host: { listeners: { "window:resize": "onResize($event)" } }, viewQueries: [{ propertyName: "unitInput", first: true, predicate: ["unit"], descendants: true }, { propertyName: "decimalInput", first: true, predicate: ["decimal"], descendants: true }], usesInheritance: true, ngImport: i0, template: `
    <div
      [formGroup]="control"
      class="form-element input-index electricity mt-4"
      [class.errors]="!control.valid && control.touched"
    >
      <div class="flex">
        <label [for]="id + '-unit'">{{ label }}</label>
        <te-tooltip
          *ngIf="tooltip?.content"
          [content]="tooltip?.content"
          [position]="tooltip?.position"
        ></te-tooltip>
      </div>
      <p class="field">
        <input
          [id]="id + '-unit'"
          type="tel"
          maxlength="6"
          placeholder="000000"
          formControlName="unit"
          DigitOnly
          (isDecimalEmitter)="moveFocusToDecimalInput()"
          #unit
        />
        <span>,</span>
        <input
          type="tel"
          [id]="id + '-decimal'"
          maxlength="1"
          placeholder="0"
          formControlName="decimal"
          DigitOnly
          #decimal
        />
      </p>
      <span class="suffix" *ngIf="suffix">{{ suffix }}</span>
      <span class="message">
        <ng-container *ngIf="!control.valid && control.touched">
          {{ errorMessage }}
        </ng-container>
      </span>
    </div>`, isInline: true, components: [{ type: TooltipComponent, selector: "te-tooltip", inputs: ["position", "content"] }], directives: [{ type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: DigitOnlyDirective, selector: "[DigitOnly]", inputs: ["decimal"], outputs: ["isDecimalEmitter"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputIndexElectricityComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-input-index-electricity',
                    template: `
    <div
      [formGroup]="control"
      class="form-element input-index electricity mt-4"
      [class.errors]="!control.valid && control.touched"
    >
      <div class="flex">
        <label [for]="id + '-unit'">{{ label }}</label>
        <te-tooltip
          *ngIf="tooltip?.content"
          [content]="tooltip?.content"
          [position]="tooltip?.position"
        ></te-tooltip>
      </div>
      <p class="field">
        <input
          [id]="id + '-unit'"
          type="tel"
          maxlength="6"
          placeholder="000000"
          formControlName="unit"
          DigitOnly
          (isDecimalEmitter)="moveFocusToDecimalInput()"
          #unit
        />
        <span>,</span>
        <input
          type="tel"
          [id]="id + '-decimal'"
          maxlength="1"
          placeholder="0"
          formControlName="decimal"
          DigitOnly
          #decimal
        />
      </p>
      <span class="suffix" *ngIf="suffix">{{ suffix }}</span>
      <span class="message">
        <ng-container *ngIf="!control.valid && control.touched">
          {{ errorMessage }}
        </ng-container>
      </span>
    </div>`,
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }, { type: i0.Renderer2 }]; }, propDecorators: { suffix: [{
                type: Input
            }], unitInput: [{
                type: ViewChild,
                args: ['unit']
            }], decimalInput: [{
                type: ViewChild,
                args: ['decimal']
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class InputIndexGasComponent extends InputIndex {
    constructor(fb, controller, renderer) {
        super(fb, controller, renderer);
        this.control = this.fb.group({
            unit: [''],
            decimal: [''],
        });
        this.onResize = () => this.stretchFieldContent();
    }
    ngAfterViewInit() {
        this.stretchFieldContent();
        this.control.get('decimal')?.valueChanges.subscribe(() => {
            if (this.control.get('decimal')?.value.length === 3) {
                this.decimalInput.nativeElement.setSelectionRange(0, 0);
                this.decimalInput.nativeElement.focus();
                this.decimalInput.nativeElement.blur();
            }
        });
    }
    writeValue(value) {
        if (!this.control || !value) {
            return;
        }
        this.control.setValue({
            unit: Math.floor(+value),
            decimal: +(+value % 1).toFixed(1) * 100,
        });
    }
    getValue(value) {
        console.log(Math.pow(10, value.decimal.length));
        const result = +value.unit + +value.decimal / Math.pow(10, value.decimal.length);
        return result;
    }
    stretchFieldContent() {
        super.stretchDecimalFieldContent(this.decimalInput);
        super.stretchUnitFieldContent(this.unitInput);
    }
    setRequired() {
        this.control.get('unit')?.addValidators([Validators.required]);
    }
    moveFocusToDecimalInput() {
        this.decimalInput.nativeElement.focus();
    }
}
InputIndexGasComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputIndexGasComponent, deps: [{ token: i1.FormBuilder }, { token: i1.NgControl }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
InputIndexGasComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputIndexGasComponent, selector: "te-input-index-gas", inputs: { suffix: "suffix" }, host: { listeners: { "window:resize": "onResize($event)" } }, viewQueries: [{ propertyName: "unitInput", first: true, predicate: ["unit"], descendants: true }, { propertyName: "decimalInput", first: true, predicate: ["decimal"], descendants: true }], usesInheritance: true, ngImport: i0, template: `<div
    [formGroup]="control"
    class="form-element input-index gas mt-4"
    [class.errors]="
      (!control.valid || !controller.control?.valid) && control.touched
    "
  >
    <div class="flex">
      <label [for]="id + '-unit'">{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>
    <p class="field">
      <input
        type="tel"
        [id]="id + '-unit'"
        maxlength="5"
        placeholder="00000"
        formControlName="unit"
        DigitOnly
        (isDecimalEmitter)="moveFocusToDecimalInput()"
        #unit
      />
      <span>,</span>
      <input
        type="tel"
        [id]="id + '-decimal'"
        maxlength="3"
        placeholder="000"
        formControlName="decimal"
        DigitOnly
        #decimal
      />
    </p>

    <span class="suffix" *ngIf="suffix">{{ suffix }}</span>
    <span class="message">
      <ng-container
        *ngIf="
          (!control.valid || !controller.control?.valid) && control.touched
        "
      >
        {{ errorMessage }}
      </ng-container>
    </span>
  </div>`, isInline: true, styles: ["#gasMono-decimal{padding-left:4%}\n"], components: [{ type: TooltipComponent, selector: "te-tooltip", inputs: ["position", "content"] }], directives: [{ type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: DigitOnlyDirective, selector: "[DigitOnly]", inputs: ["decimal"], outputs: ["isDecimalEmitter"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputIndexGasComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'te-input-index-gas',
                    template: `<div
    [formGroup]="control"
    class="form-element input-index gas mt-4"
    [class.errors]="
      (!control.valid || !controller.control?.valid) && control.touched
    "
  >
    <div class="flex">
      <label [for]="id + '-unit'">{{ label }}</label>
      <te-tooltip
        *ngIf="tooltip?.content"
        [content]="tooltip?.content"
        [position]="tooltip?.position"
      ></te-tooltip>
    </div>
    <p class="field">
      <input
        type="tel"
        [id]="id + '-unit'"
        maxlength="5"
        placeholder="00000"
        formControlName="unit"
        DigitOnly
        (isDecimalEmitter)="moveFocusToDecimalInput()"
        #unit
      />
      <span>,</span>
      <input
        type="tel"
        [id]="id + '-decimal'"
        maxlength="3"
        placeholder="000"
        formControlName="decimal"
        DigitOnly
        #decimal
      />
    </p>

    <span class="suffix" *ngIf="suffix">{{ suffix }}</span>
    <span class="message">
      <ng-container
        *ngIf="
          (!control.valid || !controller.control?.valid) && control.touched
        "
      >
        {{ errorMessage }}
      </ng-container>
    </span>
  </div>`,
                    styles: [`#gasMono-decimal{ padding-left: 4%; }`]
                }]
        }], ctorParameters: function () { return [{ type: i1.FormBuilder }, { type: i1.NgControl }, { type: i0.Renderer2 }]; }, propDecorators: { suffix: [{
                type: Input
            }], unitInput: [{
                type: ViewChild,
                args: ['unit']
            }], decimalInput: [{
                type: ViewChild,
                args: ['decimal']
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class InputFileComponent extends InputAttributeBase {
    constructor() {
        super(...arguments);
        this.buttonTitle = 'Choose file';
        this.fileWrapperClass = '';
        this.fileType = '';
        this.required = false;
        this.multiple = false;
        this.loading = false;
        this.maxFileSize = 0;
        this.fileChanged = new EventEmitter();
        this.filename = '';
        this.control = new FormControl(null);
        this.onChange = (file) => { };
        this.onTouched = () => { };
    }
    set markTouch(isTouched) {
        if (isTouched) {
            this.control.markAllAsTouched();
        }
        else {
            this.control.markAsUntouched();
        }
    }
    ngOnInit() {
        // max file size validator
        if (this.maxFileSize) {
            this.control.addValidators(maxFileSizeValidator(this.maxFileSize));
            this.control.updateValueAndValidity();
        }
        // required validator
        if (this.required) {
            this.control.addValidators(Validators.required);
            this.control.updateValueAndValidity();
        }
    }
    writeValue(file) {
        this.filename = file ? file?.name : '';
        this.control.patchValue(file);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    registerOnValidatorChange(fn) {
        this.onChange = fn;
    }
    validate(parentControl) {
        // remove required validation from this component control if parent control doesn't contain it
        if (this.control.hasValidator(Validators.required) &&
            !parentControl.hasValidator(Validators.required)) {
            this.control.removeValidators(Validators.required);
            this.control.updateValueAndValidity();
        }
        // if this component control field is invalid, the max size of the file has been exceeded
        if (!this.control.valid) {
            return { maxFileSize: true };
        }
        // if form control is invalid via ControlValueAccesor, it's because of required
        return parentControl.valid ? null : { required: true };
    }
    onFileChange(event) {
        const files = event.target.files;
        if (files?.length && files.length > 0) {
            this.control.patchValue(files[0]);
            this.filename = '';
            let index = 0;
            Array.from(files).forEach((file) => {
                index++;
                this.filename += `${file.name}${index === files.length ? '' : ';'} `;
            });
            this.onChange(this.control.value);
            this.touchControl();
            this.fileChanged.emit(event);
        }
    }
    onDialogCancel() {
        this.touchControl();
    }
    touchControl() {
        this.control.markAsTouched();
        this.control.updateValueAndValidity();
        this.onTouched();
    }
    removeFile() {
        this.fileChanged.emit();
        this.control.patchValue(null);
        this.onChange(null);
        this.filename = '';
    }
}
InputFileComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputFileComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
InputFileComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: InputFileComponent, selector: "te-input-file", inputs: { buttonTitle: "buttonTitle", fileWrapperClass: "fileWrapperClass", fileType: "fileType", required: "required", multiple: "multiple", loading: "loading", maxFileSize: "maxFileSize", markTouch: "markTouch" }, outputs: { fileChanged: "fileChanged" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputFileComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => InputFileComponent),
            multi: true,
        },
    ], usesInheritance: true, ngImport: i0, template: "<div\n  class=\"form-element input-text mt-4\"\n  [class.errors]=\"\n       !control.valid && control.touched\n    \">\n  <div class=\"flex\">\n    <label [for]=\"id\" *ngIf=\"label\">{{ label }}</label>\n    <te-tooltip\n      *ngIf=\"tooltip?.content\"\n      [content]=\"tooltip?.content\"\n      [position]=\"tooltip?.position\"></te-tooltip>\n  </div>\n  <div class=\"file-wrapper\" [ngClass]=\"fileWrapperClass\">\n    <div class=\"file\" (click)=\"fileInput.click()\">\n      <input\n        #fileInput\n        type=\"file\"\n        [id]=\"id\"\n        [accept]=\"fileType\"\n        (cancel)=\"onDialogCancel()\"\n        (change)=\"onFileChange($event)\"\n        [multiple]=\"multiple ? 'multiple' : ''\"\n        [disabled]=\"loading\"\n        placeholder=\"{{ placeholder }}\" />\n      <span class=\"file-custom\"></span>\n      <span *ngIf=\"!loading\" class=\"file-custom-button\">\n        <svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" [attr.title]=\"buttonTitle\">\n          <path\n            d=\"M9.49848 1.99915C9.56639 1.93124 9.64467 1.88 9.72821 1.84543C9.81173 1.8108 9.90331 1.79169 9.99935 1.79169C10.1806 1.79169 10.3619 1.86084 10.5002 1.99915L14.6669 6.16582C14.9435 6.44244 14.9435 6.89093 14.6669 7.16755C14.3903 7.44418 13.9418 7.44418 13.6651 7.16755L10.7077 4.21009V12.5C10.7077 12.8912 10.3905 13.2084 9.99935 13.2084C9.60815 13.2084 9.29101 12.8912 9.29101 12.5V4.21009L6.33355 7.16755C6.05693 7.44418 5.60844 7.44418 5.33181 7.16755C5.05519 6.89093 5.05519 6.44244 5.33181 6.16582L9.49848 1.99915Z\"\n            fill=\"#ED0000\" />\n          <path\n            d=\"M3.20768 12.5C3.20768 12.1088 2.89055 11.7917 2.49935 11.7917C2.10815 11.7917 1.79102 12.1088 1.79102 12.5V15.8334C1.79102 16.4632 2.04124 17.0673 2.48664 17.5127C2.93204 17.9581 3.53613 18.2084 4.16602 18.2084H15.8327C16.4626 18.2084 17.0667 17.9581 17.5121 17.5127C17.9575 17.0673 18.2077 16.4632 18.2077 15.8334V12.5C18.2077 12.1088 17.8906 11.7917 17.4993 11.7917C17.1081 11.7917 16.791 12.1088 16.791 12.5V15.8334C16.791 16.0875 16.69 16.3313 16.5103 16.511C16.3306 16.6907 16.0868 16.7917 15.8327 16.7917H4.16602C3.91185 16.7917 3.66809 16.6907 3.48837 16.511C3.30865 16.3313 3.20768 16.0875 3.20768 15.8334V12.5Z\"\n            fill=\"#ED0000\" />\n        </svg>\n      </span>\n      <div *ngIf=\"filename || placeholder\" class=\"filename-wrapper\">\n        <div class=\"filename\">{{ filename ? filename : placeholder }}</div>\n      </div>\n      <span *ngIf=\"loading\" class=\"spinner\"> </span>\n    </div>\n    <span *ngIf=\"filename && !loading\" class=\"filename-cross\" (click)=\"removeFile()\">\u2715</span>\n  </div>\n  <span class=\"message\" *ngIf=\"errorMessage\">\n    <ng-container *ngIf=\"!control.valid && control.touched\">\n      <span *ngFor=\"let error of (control.errors) | keyvalue; let i=index\">\n        <ng-container *ngIf=\"i < 1 && errorMessage && errorMessage[error.key]\">\n          {{ errorMessage[error.key] }}\n        </ng-container>\n      </span>\n    </ng-container>\n  </span>\n</div>\n", styles: [".file-wrapper{position:relative;width:100%}.file{position:relative;display:inline-block;cursor:pointer;margin-bottom:0;height:4.8rem;width:100%}.file input{min-width:14rem;margin:0;filter:alpha(opacity=0);opacity:0}.file-custom{position:absolute;top:0;right:0;left:0;z-index:5;height:4.8rem;padding:.5rem 1.5rem;line-height:2.1;color:#555;background-color:#fff;border:.075rem solid #ddd;-webkit-user-select:none;user-select:none;font-size:1.6rem;border-radius:1rem}.file-custom-button{position:absolute;top:0;right:0;bottom:0;z-index:6;display:block;height:4.6rem;padding:.5rem 1.3rem .5rem 0;line-height:3.5rem;color:#fff;border-radius:0 1rem 1rem 0;font-size:1.6rem;text-align:center;font-weight:500}.file-custom-button svg{margin-top:.8rem}.filename-wrapper{position:absolute;z-index:10;font-size:1.6rem;font-weight:400;background-color:#fff;height:3rem;top:1.2rem;left:1.5rem;width:calc(100% - 6rem)}.filename{white-space:nowrap;overflow:hidden;margin-right:2.5rem;line-height:2.4rem}.filename-cross{position:absolute;right:5rem;top:1rem;line-height:140%;color:var(--color-primary);cursor:pointer;z-index:10;font-size:2rem}.errors .file-custom{border:1px solid var(--color-error)}.spinner{position:absolute;top:1.1rem;right:1rem;bottom:0;z-index:6;display:block;height:2.5rem;width:2.5rem;animation:spin 1s linear infinite;border-radius:9999px;border-color:var(--color-grey);border-width:.2rem;border-style:solid;border-top-color:var(--color-primary)}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"], components: [{ type: TooltipComponent, selector: "te-tooltip", inputs: ["position", "content"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "keyvalue": i3.KeyValuePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: InputFileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'te-input-file', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => InputFileComponent),
                            multi: true,
                        },
                        {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef(() => InputFileComponent),
                            multi: true,
                        },
                    ], template: "<div\n  class=\"form-element input-text mt-4\"\n  [class.errors]=\"\n       !control.valid && control.touched\n    \">\n  <div class=\"flex\">\n    <label [for]=\"id\" *ngIf=\"label\">{{ label }}</label>\n    <te-tooltip\n      *ngIf=\"tooltip?.content\"\n      [content]=\"tooltip?.content\"\n      [position]=\"tooltip?.position\"></te-tooltip>\n  </div>\n  <div class=\"file-wrapper\" [ngClass]=\"fileWrapperClass\">\n    <div class=\"file\" (click)=\"fileInput.click()\">\n      <input\n        #fileInput\n        type=\"file\"\n        [id]=\"id\"\n        [accept]=\"fileType\"\n        (cancel)=\"onDialogCancel()\"\n        (change)=\"onFileChange($event)\"\n        [multiple]=\"multiple ? 'multiple' : ''\"\n        [disabled]=\"loading\"\n        placeholder=\"{{ placeholder }}\" />\n      <span class=\"file-custom\"></span>\n      <span *ngIf=\"!loading\" class=\"file-custom-button\">\n        <svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" [attr.title]=\"buttonTitle\">\n          <path\n            d=\"M9.49848 1.99915C9.56639 1.93124 9.64467 1.88 9.72821 1.84543C9.81173 1.8108 9.90331 1.79169 9.99935 1.79169C10.1806 1.79169 10.3619 1.86084 10.5002 1.99915L14.6669 6.16582C14.9435 6.44244 14.9435 6.89093 14.6669 7.16755C14.3903 7.44418 13.9418 7.44418 13.6651 7.16755L10.7077 4.21009V12.5C10.7077 12.8912 10.3905 13.2084 9.99935 13.2084C9.60815 13.2084 9.29101 12.8912 9.29101 12.5V4.21009L6.33355 7.16755C6.05693 7.44418 5.60844 7.44418 5.33181 7.16755C5.05519 6.89093 5.05519 6.44244 5.33181 6.16582L9.49848 1.99915Z\"\n            fill=\"#ED0000\" />\n          <path\n            d=\"M3.20768 12.5C3.20768 12.1088 2.89055 11.7917 2.49935 11.7917C2.10815 11.7917 1.79102 12.1088 1.79102 12.5V15.8334C1.79102 16.4632 2.04124 17.0673 2.48664 17.5127C2.93204 17.9581 3.53613 18.2084 4.16602 18.2084H15.8327C16.4626 18.2084 17.0667 17.9581 17.5121 17.5127C17.9575 17.0673 18.2077 16.4632 18.2077 15.8334V12.5C18.2077 12.1088 17.8906 11.7917 17.4993 11.7917C17.1081 11.7917 16.791 12.1088 16.791 12.5V15.8334C16.791 16.0875 16.69 16.3313 16.5103 16.511C16.3306 16.6907 16.0868 16.7917 15.8327 16.7917H4.16602C3.91185 16.7917 3.66809 16.6907 3.48837 16.511C3.30865 16.3313 3.20768 16.0875 3.20768 15.8334V12.5Z\"\n            fill=\"#ED0000\" />\n        </svg>\n      </span>\n      <div *ngIf=\"filename || placeholder\" class=\"filename-wrapper\">\n        <div class=\"filename\">{{ filename ? filename : placeholder }}</div>\n      </div>\n      <span *ngIf=\"loading\" class=\"spinner\"> </span>\n    </div>\n    <span *ngIf=\"filename && !loading\" class=\"filename-cross\" (click)=\"removeFile()\">\u2715</span>\n  </div>\n  <span class=\"message\" *ngIf=\"errorMessage\">\n    <ng-container *ngIf=\"!control.valid && control.touched\">\n      <span *ngFor=\"let error of (control.errors) | keyvalue; let i=index\">\n        <ng-container *ngIf=\"i < 1 && errorMessage && errorMessage[error.key]\">\n          {{ errorMessage[error.key] }}\n        </ng-container>\n      </span>\n    </ng-container>\n  </span>\n</div>\n", styles: [".file-wrapper{position:relative;width:100%}.file{position:relative;display:inline-block;cursor:pointer;margin-bottom:0;height:4.8rem;width:100%}.file input{min-width:14rem;margin:0;filter:alpha(opacity=0);opacity:0}.file-custom{position:absolute;top:0;right:0;left:0;z-index:5;height:4.8rem;padding:.5rem 1.5rem;line-height:2.1;color:#555;background-color:#fff;border:.075rem solid #ddd;-webkit-user-select:none;user-select:none;font-size:1.6rem;border-radius:1rem}.file-custom-button{position:absolute;top:0;right:0;bottom:0;z-index:6;display:block;height:4.6rem;padding:.5rem 1.3rem .5rem 0;line-height:3.5rem;color:#fff;border-radius:0 1rem 1rem 0;font-size:1.6rem;text-align:center;font-weight:500}.file-custom-button svg{margin-top:.8rem}.filename-wrapper{position:absolute;z-index:10;font-size:1.6rem;font-weight:400;background-color:#fff;height:3rem;top:1.2rem;left:1.5rem;width:calc(100% - 6rem)}.filename{white-space:nowrap;overflow:hidden;margin-right:2.5rem;line-height:2.4rem}.filename-cross{position:absolute;right:5rem;top:1rem;line-height:140%;color:var(--color-primary);cursor:pointer;z-index:10;font-size:2rem}.errors .file-custom{border:1px solid var(--color-error)}.spinner{position:absolute;top:1.1rem;right:1rem;bottom:0;z-index:6;display:block;height:2.5rem;width:2.5rem;animation:spin 1s linear infinite;border-radius:9999px;border-color:var(--color-grey);border-width:.2rem;border-style:solid;border-top-color:var(--color-primary)}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"] }]
        }], propDecorators: { buttonTitle: [{
                type: Input
            }], fileWrapperClass: [{
                type: Input
            }], fileType: [{
                type: Input
            }], required: [{
                type: Input
            }], multiple: [{
                type: Input
            }], loading: [{
                type: Input
            }], maxFileSize: [{
                type: Input
            }], markTouch: [{
                type: Input
            }], fileChanged: [{
                type: Output
            }] } });
const maxFileSizeValidator = (maxFileSize) => {
    return (control) => {
        return control.value &&
            maxFileSize &&
            control.value.size > maxFileSize * 1000 * 1024
            ? { maxFileSize: true }
            : null;
    };
};

class ScrollToService {
    constructor(document) {
        this.document = document;
    }
    scrollToElement(options) {
        if (!options || !options.target)
            return;
        const element = this.document.getElementById(options.target);
        if (element) {
            const rect = element.getBoundingClientRect(); // get the position of the element relative to the viewport
            const windowScrollTop = window.scrollY || this.document.documentElement.scrollTop; // get the current scroll position in viewport
            const elementTop = rect.top + windowScrollTop;
            const positionToScroll = elementTop + (options?.offset || 0);
            this.document.documentElement.scrollTo({
                top: positionToScroll,
                behavior: 'smooth',
            });
        }
    }
}
ScrollToService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ScrollToService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
ScrollToService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ScrollToService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ScrollToService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

class TotalenergiesUiLibraryModule {
}
TotalenergiesUiLibraryModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TotalenergiesUiLibraryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TotalenergiesUiLibraryModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TotalenergiesUiLibraryModule, declarations: [InputTextComponent,
        InputEmailComponent,
        ButtonComponent,
        TooltipComponent,
        InputSelectComponent,
        InputCheckboxComponent,
        InputRadiosComponent,
        InputTextareaComponent,
        InputAutocompleteComponent,
        InputIbanComponent,
        InputEanComponent,
        InputDateComponent,
        InputVatComponent,
        InputPhoneComponent,
        InputIndexElectricityComponent,
        InputIndexGasComponent,
        InputFileComponent,
        DigitOnlyDirective], imports: [CommonModule, ReactiveFormsModule], exports: [TooltipComponent,
        InputTextComponent,
        InputEmailComponent,
        InputSelectComponent,
        InputCheckboxComponent,
        InputRadiosComponent,
        InputTextareaComponent,
        InputAutocompleteComponent,
        InputIbanComponent,
        InputEanComponent,
        InputDateComponent,
        InputVatComponent,
        InputPhoneComponent,
        ButtonComponent,
        InputIndexElectricityComponent,
        InputIndexGasComponent,
        InputFileComponent] });
TotalenergiesUiLibraryModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TotalenergiesUiLibraryModule, providers: [
        ScrollToService
    ], imports: [[CommonModule, ReactiveFormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TotalenergiesUiLibraryModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        InputTextComponent,
                        InputEmailComponent,
                        ButtonComponent,
                        TooltipComponent,
                        InputSelectComponent,
                        InputCheckboxComponent,
                        InputRadiosComponent,
                        InputTextareaComponent,
                        InputAutocompleteComponent,
                        InputIbanComponent,
                        InputEanComponent,
                        InputDateComponent,
                        InputVatComponent,
                        InputPhoneComponent,
                        InputIndexElectricityComponent,
                        InputIndexGasComponent,
                        InputFileComponent,
                        DigitOnlyDirective,
                    ],
                    imports: [CommonModule, ReactiveFormsModule],
                    providers: [
                        ScrollToService
                    ],
                    exports: [
                        TooltipComponent,
                        InputTextComponent,
                        InputEmailComponent,
                        InputSelectComponent,
                        InputCheckboxComponent,
                        InputRadiosComponent,
                        InputTextareaComponent,
                        InputAutocompleteComponent,
                        InputIbanComponent,
                        InputEanComponent,
                        InputDateComponent,
                        InputVatComponent,
                        InputPhoneComponent,
                        ButtonComponent,
                        InputIndexElectricityComponent,
                        InputIndexGasComponent,
                        InputFileComponent,
                    ],
                }]
        }] });

/*
 * Public API Surface of totalenergies-ui-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonComponent, ButtonType, DigitOnlyDirective, EnergyType, InputAutocompleteComponent, InputCheckboxComponent, InputDateComponent, InputEanComponent, InputEmailComponent, InputFileComponent, InputIbanComponent, InputIndexElectricityComponent, InputIndexGasComponent, InputPhoneComponent, InputRadiosComponent, InputSelectComponent, InputTextComponent, InputTextareaComponent, InputVatComponent, ScrollToService, TooltipComponent, TooltipPosition, TotalenergiesUiLibraryModule, maxDateValidator, minDateValidator };
